import React, { Component } from "react";
import PropTypes from "prop-types";

import dateUtils from "utils/date";

export class DisplayDate extends Component {
  render() {
    let isoDate = dateUtils.formatISO(this.props.date);
    return (
      <time dateTime={isoDate} title={isoDate}>
        { dateUtils.formatDayMonthYear(this.props.date) }
      </time>
    );
  }
}

DisplayDate.defaultProps = {
  date: new Date()
};

DisplayDate.propTypes = {
  date: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date)
  ])
};
